import { observer, inject } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import { Button, Progress } from 'antd';
import s from './style.m.less';
import { UploadType, Toast } from 'grt-web-components';
import { previewDocUrl } from '@/httpService/API';
import { Request as FileRequest } from '@/api/fileManagement';
import { Upload as GrtUpload } from 'grt-web-components';
import { cloneDeep } from 'lodash';
import { themeSourceImgFromObs } from '@/utils/global';
import { Display } from '@/components/Display/Display';
import yxcg_upLoadDoc from '@/assets/images/researchResult/yxcg_upLoadDoc.png';
import yxcg_upLoadPdf from '@/assets/images/researchResult/yxcg_upLoadPdf.png';
import MyIcon from '@/components/MyIcon/MyIcon';
import ConfirmTip from '@/components/confirm';
import { customFileName } from '@/utils/downloadFile';
const UploadTypeSigin = (props) => {
    // auditState 1 编辑 2 详情
    const { en_name, name, setting, value, required } = props.updatedInfo;
    const { auditState, isRegBtn } = props;
    const [isUpload, setIsUpload] = useState(false),
        [docList, setDocList] = useState([]),
        fileListRef = useRef([]);
    useEffect(() => {
        setDocList(props.value || []);
    }, [props.value]);
    const conPreview = (ele) => {
            if (ele.ext_type === 'pdf') {
                window.open(previewDocUrl + encodeURIComponent(window.btoa(ele.url || ele.default_url)));
            }
        },
        download = (ele) => {
            // window.open(ele.url || ele.default_url);
            customFileName(ele.url || ele.default_url, ele.name, ele.ext_type);
        },
        completeItemUpload = (result) => {
            const list = docList;
            for (let i = 0, len = list.length; i < len; i++) {
                const item = list[i];
                if (item['fileName'] === result.objectKey) {
                    item.bucket = result.bucketName;
                    item.ext_type = result.ext;
                    item.fingerprint = result.md5;
                    item.obs_id = result.objectKey;
                    item.default_url = result.fileUrl;
                    item.type = 5;
                    item.status = 'success';
                    item.percent = 100;
                }
            }
            setIsUpload(false);
            setDocList(cloneDeep(list));
            fileListRef.current = cloneDeep(list);
            if (props.onChangeDocList) {
                props.onChangeDocList(docList, en_name);
            }
        },
        insertNodeLocalUpload = (data) => {
            completeItemUpload(data);
        },
        updateProcess = (process, file, xhr, obsResult) => {
            const list = docList;
            for (let i = 0, len = list.length; i < len; i++) {
                const item = list[i];
                if (item['fileName'] === obsResult.objectKey) {
                    item.status = 'active';
                    item.percent = Math.floor(process * 100);
                    item.uploadSize = process * file.size;
                    item.totalSize = item.size;
                    item.md5 = obsResult.md5;
                }
            }
            setIsUpload(true);
            setDocList(cloneDeep(list));
        },
        processFuncHandle = (process, file, xhr, obsResult) => {
            updateProcess(process, file, xhr, obsResult);
        },
        beforeUploadHandle = async (file, name) => {
            const list = docList || [];
            for (let i = 0, len = list.length; i < len; i++) {
                const item = list[i];
                if (item['name'] === file.name && item.status !== 'exception') {
                    Toast.error('文件已存在、类型不支持或大小超限');
                    return false;
                }
            }

            if (fileListRef.current.length >= 3) {
                Toast.error('超出文件上传个数');
                return false;
            }
            const tmp = {
                key: name,
                name: file.name,
                fileName: name,
                status: 'normal',
                totalSize: file.size,
                size: file.size,
                percent: 0
            };
            list.push(tmp);
            setIsUpload(true);
            fileListRef.current = cloneDeep(list);
            setDocList(cloneDeep(list));
        },
        uploadFileErrorHandle = (error, file, obsResult) => {
            if (error.message) {
                Toast.info('文件已存在、类型不支持或大小超限');
            } else {
                const list = docList;
                for (let i = 0, len = list.length; i < len; i++) {
                    const item = list[i];
                    if (item['fileName'] === obsResult.objectKey) {
                        item.status = 'exception';
                        item.totalSize = item.size;
                    }
                }
                setDocList(cloneDeep(list));
                setIsUpload(false);
            }
        },
        confirmDelete = (data) => {
            const uploadLists = docList;
            console.log(JSON.stringify(data), '==data');
            if (data.obs_id) {
                ConfirmTip({
                    title: '确认删除该文件？',
                    content: '',
                    onOk: () => {
                        uploadLists.forEach((item, index) => {
                            if (item.name === data.name) {
                                uploadLists.splice(index, 1);
                            }
                        });
                        setDocList(cloneDeep(uploadLists));
                        fileListRef.current = uploadLists;
                        if (props.onChangeDocList) {
                            props.onChangeDocList(docList, en_name);
                        }
                    }
                });
            } else {
                if (data.percent !== 100 && data.status !== 'exception') {
                    ConfirmTip({
                        title: '文件正在上传，确认删除该文件？',
                        content: '',
                        onOk: () => {
                            uploadLists.forEach((item, index) => {
                                if (item.name === data.name) {
                                    uploadLists.splice(index, 1);
                                }
                            });
                            setDocList(cloneDeep(uploadLists));
                            fileListRef.current = uploadLists;
                            if (props.onChangeDocList) {
                                props.onChangeDocList(docList, en_name);
                            }
                        }
                    });
                } else {
                    uploadLists.forEach((item, index) => {
                        if (item.name === data.name) {
                            uploadLists.splice(index, 1);
                        }
                    });
                    setDocList(cloneDeep(uploadLists));
                    fileListRef.current = uploadLists;
                    if (props.onChangeDocList) {
                        props.onChangeDocList(docList, en_name);
                    }
                }
            }
        },
        isEditorTips = () => {
            if (docList?.length === 3) {
                return Toast.error('附件数量已达上限');
            }
            if (isUpload) {
                return Toast.error('文件上传中');
            }
        },
        createFileName = (name, type) => {
            const dotIndex = name.lastIndexOf('.'),
                fileName = name.slice(0, dotIndex), // 获取文件名
                extension = name.slice(dotIndex + 1); // 获取扩展名
            return type === 1 ? fileName : extension;
        };
    return (
        // isRegBtn 1 我的报名查看详情页尺寸弹窗
        <div className={auditState === 1 ? s['question-item'] : isRegBtn === 1 || isRegBtn === '1' ? s['question-infoMy'] : s['question-info']}>
            {auditState === 1 ? (
                <div>
                    <div className={s['question-name']}>
                        {' '}
                        {required === 0 ? <i>*</i> : null}
                        {name}
                    </div>
                    <div className={s['uploadAttachments']}>
                        <Display show={setting?.templates?.length}>
                            <div className={s['attachmentTemplate-box']}>
                                <div className={s['box-title']}>
                                    <i></i>附件模版
                                </div>
                                <div className={s['box-list']}>
                                    {setting?.templates &&
                                        setting?.templates?.length &&
                                        setting?.templates.map((file, index) => (
                                            <div className={s['uploadList-list']} key={index}>
                                                <div className={s['list-title']}>
                                                    <MyIcon type={'icon-a-lianjie21'} className={s['icon']}></MyIcon>
                                                    <span>{file.name}</span>.{file.ext_type}
                                                </div>
                                                <div className={s['list-con']}>
                                                    {file.ext_type === 'pdf' ? (
                                                        <Button type={'link'} className={'pdfPreviewBtn'} onClick={() => conPreview(file)}>
                                                            预览
                                                        </Button>
                                                    ) : null}

                                                    <Button type={'link'} onClick={() => download(file)}>
                                                        下载
                                                    </Button>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </Display>
                        <div className={s['grtUpload-box']}>
                            <GrtUpload
                                maxSize={100 * 1024 * 1024}
                                multiple={true}
                                beforeUpload={beforeUploadHandle}
                                completeFunc={insertNodeLocalUpload}
                                bucketName={FileRequest.getBbsBucketName()}
                                uploadType={UploadType.UNSET}
                                processFunc={processFuncHandle}
                                errorFunc={uploadFileErrorHandle}
                                dirname={props.dirname || props?.store?.login?.tenantInfo?.id + '/siginUp'}
                                uploadItem={
                                    <div
                                        className={s['uploadWrapper']}
                                        style={(docList && docList.length >= 3) || isUpload ? { opacity: '0.6', pointerEvents: 'none' } : null}
                                    >
                                        <div className={s['uploadWrapper-box']}>
                                            <img src={themeSourceImgFromObs?.yxcg_img?.yxcgUpload} />
                                            <div className={s['uploadWrapper-right']}>
                                                <span className={s['right-text']}>
                                                    上传附件
                                                    <MyIcon type={'icon-a-lianjie21'} className={s['icon']}></MyIcon>
                                                </span>
                                                <span className={s['right-tip']}>文件最大不超过100MB，最多上传3个文件</span>
                                            </div>
                                        </div>
                                        <div className={s['uploadWrapper-tip']}>
                                            推荐 doc，docx，xls，xlsx，ppt，pptx，pdf，csv，txt，zip，rar，png，jpg，jpeg格式
                                        </div>
                                    </div>
                                }
                            />
                            <Display show={(docList && docList.length >= 3) || isUpload}>
                                <div className={s['isEditorBack']} onClick={isEditorTips}></div>
                            </Display>
                        </div>
                        <div className={s['uploadList']}>
                            <div className={s['uploadList-item']}>
                                {docList && docList.length
                                    ? docList.map((file, index) => (
                                          <div className={s['uploadList-list']} key={index}>
                                              <div className={s['list-title']}>
                                                  <img src={file.ext_type === 'pdf' ? yxcg_upLoadPdf : yxcg_upLoadDoc} />
                                                  <span>{createFileName(file.name, 1)}</span>.{createFileName(file.name, 2)}
                                              </div>
                                              <div className={s['list-status']}>
                                                  {file.status === 'active' ? (
                                                      <span style={{ color: '#666' }}>正在上传</span>
                                                  ) : file.status === 'success' || !file.status ? (
                                                      <span style={{ color: '#07C160' }}>上传成功</span>
                                                  ) : file.status === 'exception' ? (
                                                      <span style={{ color: '#FF4D4F' }}>上传失败</span>
                                                  ) : null}
                                                  {file.status === 'active' ? (
                                                      <div style={{ width: '104px' }}>
                                                          <Progress
                                                              strokeColor={{ from: '#CFDCFF', to: '#1252FF' }}
                                                              className={s['progressList']}
                                                              percent={file.percent}
                                                              status={file.status}
                                                          />
                                                      </div>
                                                  ) : null}
                                              </div>
                                              <div className={s['list-con']}>
                                                  {file.ext_type === 'pdf' ? (
                                                      <Button type={'link'} onClick={() => conPreview(file)}>
                                                          预览
                                                      </Button>
                                                  ) : null}

                                                  <Button type={'link'} onClick={() => confirmDelete(file)}>
                                                      删除
                                                  </Button>
                                              </div>
                                          </div>
                                      ))
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={s['uploadList']}>
                    {value && value.length ? (
                        value.map((file, index) => (
                            <div className={s['uploadList-list']} key={index}>
                                <div className={s['list-title']}>
                                    <img src={file.ext_type === 'pdf' ? yxcg_upLoadPdf : yxcg_upLoadDoc} />
                                    <span>{createFileName(file.name, 1)}</span>.{createFileName(file.name, 2)}
                                </div>
                                <div className={s['list-con']}>
                                    <Button type={'link'} onClick={() => download(file)}>
                                        下载
                                    </Button>
                                    {file.ext_type === 'pdf' ? (
                                        <Button type={'link'} onClick={() => conPreview(file)}>
                                            预览
                                        </Button>
                                    ) : null}
                                </div>
                            </div>
                        ))
                    ) : (
                        <span>-</span>
                    )}
                </div>
            )}
        </div>
    );
};
export default inject('store')(observer(UploadTypeSigin));
